module.exports = __webpack_public_path__ + "img/about-13.858d97c5.jpg";